export default __webpack_public_path__ + "static/media/listDownIcon.c8b6b699.svg";